<style lang="stylus" scope>
  body
    background #efefef
  .login-form
    .form-control
      border 0
      height auto
      padding 0
    .btn.btn-primary
      border-radius 50px!important
      display block
      font-weight 600
      height auto
      padding .5em 3em
</style>
<template lang="pug">
c-app
  c-content
    section.sign.u-m-auto
      .sign__body.card
        h1.sign__title {{userinfo.name}}
        p.sign__text CAMBIO DE CONTRASEÑA
        c-form.login-form
          .form-group
            label.w-100 Contraseña Anterior
              c-form-input.mt-2(v-model='oldPassword', type='password')
          .form-group 
            label.w-100 Nueva Contraseña
              c-form-input.mt-2(v-model='password', type='password')
          .form-group
            label.w-100 Confirmar Contraseña
              c-form-input.mt-2(v-model='newPassword', type='password')
          .form-group.m-1
            button.btn.btn-primary.m-auto(type='submit', @click.prevent='auth', block='') Guardar
          .form-group.m-0
            button.btn.btn-primary.m-auto(type='submit', @click.prevent='back', block='') Volver
      footer.sign__footer.u-text-center
        p.u-text-muted.u-fs-12
          | Desarrollado por Persis
          br
          | © 2018
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ChangePwd',
  beforeRouteEnter (to, from, next) {    
    next()
  },
  props: ['logout'],
  methods: {
    ...mapActions('auth', [
      'changePwd',
      'login'
    ]),
    ...mapActions('objective', [
      'cleanStore'
    ]),
    ...mapActions('plan', [
      'cleanStorePlan'
    ]),
    back() {
      this.$router.replace('/')
    },
    auth () {
      const vm = this
      if (this.password !== this.newPassword) {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: "La nueva clave debe ser igual a la confirmada.",
          closeable: true,
          duration: 5000
        })} else {
      const loading = vm.$toast.loading('Cargando...')
      vm.changePwd({
        username: vm.userinfo.username,
        password: this.oldPassword,
        newPassword: this.newPassword})
        .then((res) => {
          loading.hide()
          if (res.success) {
              vm.cleanStore()
              vm.cleanStorePlan().then(() => {
                if(this.redirect != '/' && this.redirect != null) { 
                  vm.$router.push({ path: this.redirect })
                } else {              
                  vm.$router.push({ path: '/home' })
                }
              }, (error) => {
                vm.$notify({
                  type: 'danger',
                  title: 'Notificación',
                  content: res.message,
                  closeable: true,
                  duration: 5000
                })  
              })      
          } else {            
            vm.$notify({
              type: 'danger',
              title: 'Notificación',
              content: res.message,
              closeable: true,
              duration: 5000
            })
          }
        }, (error) => {          
          loading.hide()
          vm.$notify({
            type: 'danger',
            title: 'Notificación',
            content: error.payload.message,
            closeable: true,
            duration: 5000
          })
        })
      }
    }
  },
  data () {
    return {
      userinfo: {
        name: null
      },
      email: '',
      password: '',
      redirect: null,
      isLogOut: this.logout
    }
  },
  mounted () {
    this.userinfo = this.$store.getters['auth/getUserInfo']
  }
}
</script>


// WEBPACK FOOTER //
// src/views/changePwd.vue